var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":_vm.tooltipView,"placement":"bottom","open-delay":500}},[_c('v-btn',{attrs:{"icon":_vm.type === 'icon',"text":_vm.type === 'text',"to":_vm.backTo}},[_vm._t("default",function(){return [_c('v-icon',[_vm._v("mdi-arrow-left")])]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }